export default class ModuleFactory {

	/**
	 *
	 * @type {Array<{element: HTMLElement, module: Object}>}
	 */
	#holders = [];

	/**
	 *
	 * @param {Array<Object>} modules
	 */
	constructor(modules) {
		for (const module of modules) {
			this.#holders = this.#holders.concat(module.getHolderSelectors()
				.flatMap(selector => [...document.querySelectorAll(selector)])
				.map(holder => Object.create({element: holder, module: module})));
		}
		document.addEventListener('dependency-chain:loaded', this.#createReadyModules.bind(this));
		this.#createReadyModules();
	}

	#createReadyModules() {
		for (const holder of this.#holders) {
			if (holder.element.dataset.module === 'ready') {
				new holder.module(holder.element);
				holder.element.dataset.module ='created';
			}
		}
	}

}
